import { render, staticRenderFns } from "./EstablishmentReviewContent.vue?vue&type=template&id=012a279e&lang=pug&"
import script from "./EstablishmentReviewContent.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentReviewContent.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstablishmentReviewContent.vue"
export default component.exports